<!-- 这里是首页 -->
<template>
  <div class="user">
    <div class="container">
      <div class="form_info ly-border-radius">
        <el-form ref="form" :model="queryInfo" label-width="80px">
          <div class="form">
            <div class="comble_txt">
              <el-form-item label="专家类别:" prop="">
                <el-radio-group
                  v-model="queryInfo.specialistType"
                  @change="search(1)"
                >
                  <el-radio-button
                    :label="item.id"
                    v-for="(item, index) in InformationTypes"
                    :key="index"
                    >{{ item.value }}</el-radio-button
                  >
                </el-radio-group>
              </el-form-item>

              <el-form-item
                label=" "
                label-width="0px"
                style="
                  border-top: 1px dashed #efefef;
                  padding-top: 20px;
                  margin-bottom: 0;
                "
              >
                <div class="input-with">
                  <div style="display: flex; align-items: center">
                    <el-button
                      type="primary"
                      style="height: 32px; margin-right: 10px"
                      @click="toPage('addexpert', {})"
                      >新增专家</el-button
                    >
                    <import-data moduleName="专家数据" @fileClick="fileClick" />
                    <!-- <el-button style="margin-right: 5px" @click="SetGeneral"
                      >设置城市智参</el-button
                    >

                    <el-button style="margin-right: 5px" @click="updateOnShelf"
                      >批量发布</el-button
                    >
                    <el-button style="margin-right: 5px" @click="updateOffShelf"
                      >批量下架</el-button
                    >
                    <el-button
                      style="margin-right: 5px"
                      @click="checkClickexpert"
                      >设置通用版专家</el-button
                    >

                    <el-checkbox
                      style="position: relative; top: 5px"
                      :indeterminate="isIndeterminate"
                      v-model="checkAll"
                      @change="handleCheckAllChange"
                      >全选</el-checkbox
                    > -->
                    <!-- <el-checkbox
                    style="position: relative;top: 5px;"
                      v-model="checked"
                      @change="checkGeneralVersion"
                      >只查看通用版专家</el-checkbox
                    > -->

                    <!-- <el-button plain @click="setMember">设置佛山会员</el-button> -->
                  </div>
                  <div>
                    <el-input
                      placeholder="专家名称，专家简介"
                      v-model="queryInfo.conditionQuery"
                      class="input-with-select"
                    >
                      <el-button class="seach" slot="append" @click="search()"
                        >搜索</el-button
                      >
                    </el-input>
                  </div>
                </div>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>

      <div
        class="tab_txt ly-border-radius"
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
        style="background-color: #fff"
      >
        <div
          class="storeCenter_item"
          v-for="(item, index) in listData"
          :key="index"
        >
          <div class="item_checkbox">
            <el-checkbox
              @change="latechange($event, item)"
              v-model="item.checked1"
              label=""
            ></el-checkbox>
          </div>
          <div class="storeCenter_item_top">
            <div class="storeCenter_item_top_left">
              <div class="banner_box">
                <img :src="item.headPortrait" alt="" />
              </div>
              <div class="storeCenter_item_top_left_flex">
                <div style="display: flex; align-items: center">
                  <h5
                    style="
                      display: inline-block;
                      margin: 0;
                      font-size: 18px;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      display: -webkit-box;
                      -webkit-line-clamp: 1;

                      -webkit-box-orient: vertical;
                    "
                  >
                    {{ item.name }}
                  </h5>

                  <!-- <span class="generalVersion" v-if="item.generalVersion == 0"
                    >通用版</span
                  >
                  <span class="generalVersion" v-if="item.generalVersion == 1"
                    >个性版</span
                  > -->

                  <span class="generalVersion" v-if="item.specialistType == 1"
                    >通用版</span
                  >
                  <span class="generalVersion" v-if="item.specialistType == 2"
                    >渠道专家</span
                  >
                  <div class="mark_box">
                    <div v-if="item.specialistType == 1">
                      <img src="../../assets/image/Group 3298.png" alt="" />
                      <span>平台专家</span>
                    </div>
                    <div v-else>
                      <img src="../../assets/image/展厅-5 3.png" alt="" /><span
                        >渠道专家</span
                      >
                    </div>
                    <!-- 价格 -->
                    <!-- <div>
                      <img src="../../assets/image/Vector-1.png" alt="" /><span
                        >{{ item.consultingFee }}/小时</span
                      >
                    </div> -->
                  </div>
                </div>
                <div class="storeCenter_item_top_left_flex_tag">
                  <span style="display: flex" v-if="item.otherTag">
                    <span v-for="(o, index) in item.otherTag" :key="index">
                      <span v-if="index < 2" class="office">{{ o }}</span>
                    </span>
                  </span>

                  <el-popover placement="right" width="430" trigger="hover">
                    <div
                      class="hidden_label_box"
                      style="
                        width: 100%;
                        display: flex;
                        flex-direction: row;
                        align-content: center;
                        flex-wrap: wrap;
                      "
                    >
                      <span
                        class="office"
                        style="
                          border: 1px solid #559eff;
                          color: #4e93fb;
                          box-sizing: border-box;
                          padding: 1px 6px;
                          display: block;
                          font-size: 14px;
                          font-weight: 400;
                          border-radius: 4px;
                          margin-right: 10px;
                          margin-bottom: 10px;
                        "
                        v-for="(o, index) in item.otherTag"
                        :key="index"
                        >{{ o }}</span
                      >
                    </div>
                    <span
                      class="office"
                      slot="reference"
                      v-if="item.otherTag && item.otherTag.length > 2"
                      >{{ item.otherTag.length }}+</span
                    >
                  </el-popover>
                </div>
                <div>{{ item.sponsor }}</div>
                <p class="address" v-if="item.field.length">
                  <span style="padding-left: 0px">
                    擅长领域:
                    <span v-for="(o, index) in item.field" :key="index">
                      {{ o }}
                    </span>
                  </span>
                </p>
              </div>
            </div>

            <!-- 中间展示的数据 -->
            <!-- <div class="storeCenter_item_top_center">
              <div class="count_box" @click="pushedCompanyPageSpecialist(item)">
                <div>{{ item.consultNum }}</div>
                <div>推送企业数</div>
              </div>
              <div class="count_box" @click="toseek(item)">
                <div>{{ item.consultingUserCount }}</div>
                <div>咨询用户数</div>
              </div>

              <div class="count_box" @click="checkCount(item)">
                <div>{{ item.viewCount }}</div>
                <div>查看用户数</div>
              </div>
              <div class="count_box" @click="expertSharing(item)">
                <div>{{ item.shareCount }}</div>
                <div>分享用户数</div>
              </div>
            </div> -->

            <div class="storeCenter_item_top_right">
              <div class="operation_area">
                <!-- <el-button type="primary" @click="configureEnterprise(item, 2)"
                  >算法配置</el-button
                >
                <el-button
                  type="info"
                  plain
                  @click="configureEnterprise(item, 1)"
                  >手动配置</el-button
                >
                <el-button type="info" @click="clcikgensing(item)" plain
                  >配置智参
                </el-button> -->
                <el-button type="info" @click="clciklabel(item)" plain
                  >专家标签</el-button
                >
                <span
                  v-if="item.isShelf == 1"
                  class="edit"
                  @click="OnShelf(item)"
                  >发布</span
                >
                <span
                  v-if="item.isShelf == 0"
                  class="frozen"
                  @click="OffShelf(item)"
                  >下架</span
                >

                <span class="edit" @click="toPage('addexpert', item)"
                  >编辑</span
                >
                <span
                  v-if="item.isDelete == 0"
                  class="frozen"
                  @click="delcompany(item)"
                  >冻结</span
                >
                <span
                  v-if="item.isDelete == 1"
                  class="frozen"
                  @click="cancelcompany(item)"
                  >激活</span
                >
              </div>
              <div class="details">操作人：{{ item.updateName }}</div>
              <div class="details">最近操作时间：{{ item.updateTime }}</div>
            </div>
          </div>
        </div>
        <el-dialog
          title="批量配置智参中心"
          :visible.sync="dialogVisible"
          width="627px"
          class="account_dialog"
        >
          <el-form label-width="100px" :model="pageParam" ref="form">
            <el-form-item label="所在地区:" prop="">
              <el-select
                v-model="pageParam.province"
                placeholder="请选择省份"
                @change="citychange"
              >
                <el-option :value="''" label="全部"></el-option>
                <el-option
                  v-for="item in operatingList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
              <div style="display: inline-block; width: 10px"></div>
              <el-select
                v-model="pageParam.city"
                placeholder="请选择地区"
                @change="domGinsengPage"
              >
                <el-option :value="''" label="全部"></el-option>
                <el-option
                  v-for="item in operatingLists"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="中心名称：" prop="link">
              <div class="disinput">
                <el-input
                  placeholder="请输入智参中心名称"
                  v-model="pageParam.conditionQuery"
                  class="input-with-select"
                >
                  <el-button
                    style="
                      border: 1px solid #448aff;
                      background-color: #448aff;
                      color: #fff;
                      border-radius: 0;
                    "
                    class="seach"
                    slot="append"
                    @click="domGinsengPage()"
                    >搜索</el-button
                  >
                </el-input>
              </div>
            </el-form-item>
          </el-form>
          <el-table
            v-loading="loadingisen"
            element-loading-text="加载中..."
            element-loading-spinner="el-icon-loading"
            ref="multipleTable"
            :data="listgisen"
            stripe
            width="100%"
            class="in_table"
            @selection-change="handleSelectionChange"
            row-key="id"
            :header-cell-style="{ background: '#F8F9FB', color: '#595959' }"
          >
            <el-table-column
              type="selection"
              align="center"
              :reserve-selection="true"
            />
            <el-table-column
              label="智参中心名称"
              prop="zcName"
              align="center"
            ></el-table-column>
            <el-table-column label="所在地区" prop="" align="center">
              <template v-slot="{ row }">
                <span>{{ row.province }}-{{ row.city }}</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="new_page">
            <el-pagination
              :current-page="pageParam.pageNum"
              :page-sizes="[10, 30, 50]"
              :page-size="pageParam.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totaldins"
              @size-change="handleSize"
              @current-change="handleCurrent"
            />
          </div>
          <div style="text-align: center; margin-top: 40px">
            <el-button type="primary" @click="checkClick()">确 定</el-button>
            <el-button @click="dialogVisible = false">取 消</el-button>
          </div>
        </el-dialog>
        <el-dialog
          title="配置智参中心"
          :visible.sync="dialogVisibles"
          width="700px"
          class="account_dialog"
        >
          <el-form label-width="100px" :model="pageParam" ref="form">
            <el-form-item label="所在地区:" prop="">
              <el-select
                v-model="pageParam.province"
                placeholder="请选择省份"
                @change="citychange"
              >
                <el-option :value="''" label="全部"></el-option>
                <el-option
                  v-for="item in operatingList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
              <div style="display: inline-block; width: 10px"></div>
              <el-select
                v-model="pageParam.city"
                placeholder="请选择地区"
                @change="wisdomGinsengPage"
              >
                <el-option :value="''" label="全部"></el-option>
                <el-option
                  v-for="item in operatingLists"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="中心名称：" prop="link">
              <div class="disinput">
                <el-input
                  placeholder="请输入智参中心名称"
                  v-model="pageParam.conditionQuery"
                  class="input-with-select"
                >
                  <el-button
                    style="
                      border: 1px solid #448aff;
                      background-color: #448aff;
                      color: #fff;
                      border-radius: 0;
                    "
                    class="seach"
                    slot="append"
                    @click="wisdomGinsengPage()"
                    >搜索</el-button
                  >
                </el-input>
              </div>
            </el-form-item>
            <div class="add_search">
              <div class="left">
                <el-button style="margin-right: 5px" @click="setShelf(1)"
                  >批量上架</el-button
                >
                <el-button style="margin-right: 5px" @click="setShelf(2)"
                  >批量下架</el-button
                >
              </div>
            </div>
          </el-form>
          <el-table
            ref="multipleTables"
            v-loading="loadingisen"
            element-loading-text="加载中..."
            element-loading-spinner="el-icon-loading"
            :data="listgisen"
            stripe
            width="100%"
            class="in_table"
            @selection-change="handleSelectionChange"
            row-key="id"
            :header-cell-style="{ background: '#F8F9FB', color: '#595959' }"
          >
            <el-table-column
              type="selection"
              align="center"
              :reserve-selection="true"
            />
            <el-table-column
              label="智参中心名称"
              prop="zcName"
              align="center"
            ></el-table-column>
            <el-table-column label="所在地区" prop="" align="center">
              <template v-slot="{ row }">
                <span>{{ row.province }}-{{ row.city }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="操作人"
              prop="updateName"
              align="center"
            ></el-table-column>

            <el-table-column
              label="操作时间"
              prop="createTime"
              align="center"
            ></el-table-column>

            <el-table-column label="操作" prop="" align="center">
              <template v-slot="{ row }">
                <span
                  v-if="row.isShelf == 1"
                  @click="setShelf(1, row, 1)"
                  class="support"
                  >上架</span
                >
                <span
                  v-if="row.isShelf == 0"
                  @click="setShelf(2, row, 1)"
                  class="office"
                  >下架</span
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="new_page">
            <el-pagination
              :current-page="pageParam.pageNum"
              :page-sizes="[10, 30, 50]"
              :page-size="pageParam.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totaldins"
              @size-change="handleSizeChanges"
              @current-change="handleCurrentChanges"
            />
          </div>
          <div style="text-align: center; margin-top: 40px">
            <el-button type="primary" @click="dialogVisibles = false"
              >确 定</el-button
            >
            <el-button @click="dialogVisibles = false">取 消</el-button>
          </div>
        </el-dialog>
      </div>
    </div>

    <div class="new_page" v-if="listData.length">
      <el-pagination
        :current-page="queryInfo.pageNum"
        :page-sizes="[10, 30, 50]"
        :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import {
  updateGeneralVersion,
  getCompanySpecialistList,
  updateWisdomGinseng,
  cancelFreezeSpecialist,
  freezeSpecialist,
  wisdomGinsengPage,
  wisdomGinsengOnSelf,
  wisdomGinsengOffSelf,
  updateOnShelf,
  updateOffShelf,
  getByIdEx,
  getListByCondition,
  deleteEx,
  canelFreezeSpecialist
} from "@/api/expert";
import { domGinsengPage } from "../../api/content.js";
import { getProvince } from "@/api/demand";
import ImportData from "../../components/ImportData.vue";
const defaultQueryInfo = Object.freeze({
  generalVersion: null,
  orderByParam: null,
  pageNum: 1,
  pageSize: 10,
  conditionQuery: null,
  specialistType: null
});
export default {
  name: "expert",
  components: {
    ImportData
  },
  data() {
    return {
      InformationTypes: [
        {
          value: "全部",
          id: null
        },
        {
          value: "平台专家",
          id: "1"
        },
        {
          value: "渠道专家",
          id: "2"
        }
      ],

      checked: false,

      dialogVisible: false, //哦批量设置智参弹窗
      dialogVisibles: false,
      //批量设置智参中心筛选条件
      pageParam: {
        city: null,
        id: null,
        orderByParam: null,
        pageNum: 1,
        pageSize: 10,
        province: null,
        queryConditions: null
      }, //配置智参中心
      ids: [],
      idsList: [],
      queryInfo: { ...defaultQueryInfo },
      listData: [],
      loading: false, // 遮罩层
      loadingisen: false, //配置智参
      total: 0, // 总条数
      listgisen: [],
      totaldins: 0,
      idgisen: [],
      checkAll: false,
      isIndeterminate: false,
      operatingList: [], //城市
      operatingLists: [], //市
      bol: false
    };
  },
  // activated() {
  //   if (this.bol) {
  //     this.search();
  //   }
  // },
  created() {
    if (!this.bol) {
      this.search();
      this.bol = true;
    }
  },
  methods: {
    fileClick() {
      this.search();
    },
    //城市
    async incity() {
      const res = await getProvince();
      if (res.data.resultCode == 200) {
        this.operatingList = res.data.data;
      }
    },
    // 查询接口写完了+
    async search(num) {
      if (num == 1) {
        this.queryInfo.pageNum = 1;
      }

      this.loading = true;
      const res = await getListByCondition(this.queryInfo);
      if (res.code == 200) {
        this.listData = res.data.list;
        this.listData.forEach(el => {
          this.$set(el, "checked1", false);
        });
        this.total = res.data.total;
        this.loading = false;
        this.listData.forEach(item => {
          if (item.labelName != null) {
            item.otherTag = item.otherTag.slice(0, 3);
          }
          if (item.field != null) {
            item.field = item.field.slice(0, 2);
          }
        });
      }
    },
    handleCheckAllChange(val) {
      if (val) {
        this.listData.forEach(item => {
          this.ids.push(item.id);
          this.idsList.push(item);
          this.$set(item, "checked1", true);
        });
      } else {
        this.listData.forEach(item => {
          this.ids = [];
          this.idsList = [];
          this.$set(item, "checked1", false);
        });
      }
      this.isIndeterminate = val;
    },
    // 切换搜索列表的参数
    checkParams(key, val) {
      this.queryInfo[key] = val;
      this.search();
    },
    checkParamsData(val) {
      this.queryInfo.activityStartTime = val[0];
      this.queryInfo.activityEndTime = val[1];
      this.search();
    },
    checkGeneralVersion(bol) {
      if (bol) {
        this.queryInfo.generalVersion = 0;
      } else {
        this.queryInfo.generalVersion = "";
      }
      this.search();
    },
    //批量设置智参
    SetGeneral() {
      if (this.ids.length > 0) {
        this.dialogVisible = true;
        this.domGinsengPage();
        this.incity();
      } else {
        this.$message.warning("请选择专家");
      }
    },
    //批量下架
    updateOffShelf() {
      if (this.ids.length > 0) {
        const that = this;
        this.$alert("是否确认批量下架专家？")
          .then(function() {
            return updateOffShelf(that.ids);
          })
          .then(() => {
            this.search();
            this.ids = [];
            this.isIndeterminate = false;
            this.checkAll = false;
            this.$message.success("下架成功");
          })
          .catch(() => {});
      } else {
        this.$message.warning("请选择专家");
      }
    },
    //批量上架
    updateOnShelf() {
      if (this.ids.length > 0) {
        const that = this;
        this.$alert("是否确认批量上架专家？")
          .then(function() {
            return updateOnShelf(that.ids);
          })
          .then(() => {
            this.search();
            this.ids = [];
            this.isIndeterminate = false;
            this.checkAll = false;
            this.$message.success("上架成功");
          })
          .catch(() => {});
      } else {
        this.$message.warning("请选择专家");
      }
    },
    //城市选择
    citychange(item) {
      this.operatingList.forEach(o => {
        if (this.pageParam.province == o.name) {
          this.pageParam.city = "";
          if (item == "全部") {
            this.operatingLists = this.operatingList
              .map(el => el.cityResults)
              .flat(Infinity);
          } else {
            this.operatingLists = this.operatingList.find(
              el => el.name == item
            ).cityResults;
          }
        }
      });
    },
    //批量下架
    OffShelf(row) {
      const ids = [];
      ids.push(row.id);
      this.$alert("是否确认下架专家？")
        .then(function() {
          return updateOffShelf(ids);
        })
        .then(() => {
          this.search();
          this.$message.success("下架成功");
        })
        .catch(() => {});
    },
    //批量上架
    OnShelf(row) {
      const ids = [];
      ids.push(row.id);
      this.$alert("是否确认上架专家？")
        .then(function() {
          return updateOnShelf(ids);
        })
        .then(() => {
          this.search();
          this.$message.success("上架成功");
        })
        .catch(() => {});
    },
    // 上下架
    setShelf(type, row, index) {
      let reportId = "";
      if (index === 1) {
        this.idgisen = [row.schemaName];
        reportId = row.specialistId;
      } else {
        reportId = this.pageParam.id;
      }
      if (this.idgisen.length > 0) {
        const query = {
          reportId,
          schemaNames: this.idgisen
        };
        const bol = type === 1 ? true : false;
        const fn = bol ? wisdomGinsengOnSelf : wisdomGinsengOffSelf;
        const txt = bol ? "上架" : "下架";
        const that = this;
        this.$alert("是否确认" + txt + "？")
          .then(function() {
            return fn(query);
          })
          .then(() => {
            that.wisdomGinsengPage();
            that.idgisen = [];
            this.$refs.multipleTables.clearSelection();
            this.$message.success(txt + "成功");
          })
          .catch(() => {});
      } else {
        this.$message.warning("请选择智参中心");
      }
    },
    //配置智参
    clcikgensing(row) {
      this.pageParam.id = row.id;
      this.dialogVisibles = true;
      this.wisdomGinsengPage();
      this.incity();
    },
    //专家配置智参中心数据一览
    async wisdomGinsengPage() {
      this.loadingisen = true;
      const { data: res } = await wisdomGinsengPage(this.pageParam);
      if (res.resultCode == 200) {
        this.listgisen = res.data.list;
        this.totaldins = res.data.total;
        this.loadingisen = false;
      }
    },
    //分页查询智参中心
    async domGinsengPage() {
      delete this.pageParam.id;
      this.loadingisen = true;
      const { data: res } = await domGinsengPage(this.pageParam);
      if (res.resultCode == 200) {
        this.listgisen = res.data.list;
        this.totaldins = res.data.total;
        this.loadingisen = false;
      }
    },
    //批量选择智参
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.idgisen = selection.map(item => item.schemaName);
    },
    // 分页专家配置智参中心数据一览
    handleSizeChanges(val) {
      this.pageParam.pageSize = val;
      this.wisdomGinsengPage();
    },
    // 分页专家配置智参中心数据一览
    handleCurrentChanges(val) {
      this.pageParam.pageNum = val;
      this.wisdomGinsengPage();
    },
    // 分页专家配置智参中心数据一览
    handleSize(val) {
      this.pageParam.pageSize = val;
      this.domGinsengPage();
    },
    // 分页专家配置智参中心数据一览
    handleCurrent(val) {
      this.pageParam.pageNum = val;
      this.domGinsengPage();
    },
    //冻结专家
    delcompany(row) {
      const params = {
        specialistIds: row.id
      };
      this.$alert("您是否确认冻结？")
        .then(function() {
          return deleteEx(params);
        })
        .then(() => {
          this.search();
          this.$message.success("冻结成功");
        })
        .catch(() => {});
    },
    //激活专家
    cancelcompany(row) {
      const params = {
        id: row.id
      };
      this.$alert("您是否确认激活？")
        .then(function() {
          return canelFreezeSpecialist(params);
        })
        .then(res => {
          if (res.code == 200) {
            this.search();
            this.$message.success("激活成功");
          } else {
            this.$message.warning(res.data);
          }
        })
        .catch(() => {});
    },
    // 点击编辑进入子组件
    toPage(type, row) {
      if (type == "addexpert") {
        this.$router.push({
          path: "/expert/expertInfo",
          query: {
            id: row.id,
            headTabActive: "first"
          }
        });
      }
    },
    //配置企业
    configureEnterprise(row, index) {
      this.$router.push({
        path: "/expert/configureEnterprise",
        query: {
          id: row.id,
          type: index
        }
      });
    },
    //咨询用户数
    toseek(row) {
      this.$router.push({
        name: "SeekAdvice",
        query: {
          id: row.id
        }
      });
    },
    //标签
    clciklabel(row) {
      // this.$router.push({
      //   path: "/expert/addexpert",
      //   query: {
      //     id: row.id,
      //     headTabActive: 2,
      //   },
      // });
      this.$router.push({
        path: "/expert/expertInfo",
        query: {
          id: row.id,
          headTabActive: "third"
        }
      });
    },
    //关联用户
    UserClick(item) {
      this.$router.push({
        name: "CorrelateUser",
        query: {
          id: item.id,
          secretaryGeneralName: item.secretaryGeneralName,
          chamberCommerceName: item.chamberCommerceName
        }
      });
    },
    latechange(bol, row) {
      const index = this.ids.indexOf(row.id);
      if (index == -1) {
        this.ids.push(row.id);
        this.idsList.push(row);
      } else {
        this.ids.splice(index, 1);
        this.idsList.splice(index, 1);
      }
    },
    //批量设置专家智参中心
    checkClick() {
      if (this.ids.length > 0) {
        const query = {
          ids: this.ids,
          schemaNames: this.idgisen
        };
        const that = this;
        this.$alert("是否确认设置为此智参的专家？")
          .then(function() {
            return updateWisdomGinseng(query);
          })
          .then(() => {
            this.search();
            this.ids = [];
            this.isIndeterminate = false;
            this.checkAll = false;
            this.dialogVisible = false;
            this.idgisen = [];
            this.$refs.multipleTable.clearSelection();
            this.$message.success("设置成功");
          })
          .catch(() => {});
      } else {
        this.$message.warning("请选择专家");
      }
    },
    // 设置通用版专家
    checkClickexpert() {
      const that = this;
      this.$alert("是否确认设置成通用专家？")
        .then(function() {
          return updateGeneralVersion(that.ids);
        })
        .then(res => {
          this.$message.success("设置成功");
          this.search();
          this.ids = [];
          this.$refs.multipleTable.clearSelection();
        })
        .catch(() => {});
    },
    //查看人数
    checkCount(item) {
      this.$router.push({
        name: "checkCount",
        query: {
          id: item.id,
          pageType: 1
        }
      });
    },
    //分享人数
    expertSharing(item) {
      this.$router.push({
        name: "expertSharing",
        query: {
          id: item.id,
          pageType: 2
        }
      });
    },
    // 点击中间的数据，跳转到子级页面
    pushedCompanyPageSpecialist(item) {
      this.$router.push({
        name: "PushexpertCompany",
        query: {
          id: item.id
        }
      });
    },
    // 分页
    handleSizeChange(val) {
      this.queryInfo.pageSize = val;
      this.search();
      // console.log(`每页 ${val} 条`)
    },
    // 分页
    handleCurrentChange(val) {
      this.queryInfo.pageNum = val;
      this.search();
      // console.log(`当前页: ${val}`)
    }
  }
};
</script>

<style lang="less" scoped>
::v-deep .el-checkbox__inner::after {
  box-sizing: content-box;
  content: "";
  border: 1px solid #fff;
  border-left: 0;
  border-top: 0;
  height: 7px;
  left: 5px;
  position: absolute;
  top: 2px;
  transform: rotate(45deg) scaleY(0);
  width: 4px;
  transition: transform 0.15s ease-in 50ms;
  transform-origin: center;
}
::v-deep .el-checkbox__inner {
  display: inline-block;
  position: relative;
  border: 1px solid #dcdfe6;
  border-radius: 2px;
  box-sizing: border-box;
  width: 18px;
  height: 18px;
  background-color: #fff;
  z-index: 1;
  transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
    background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);
}
.office {
  color: #4e93fb;

  cursor: pointer;
}

.support {
  cursor: pointer;
  color: #fd523f;
}

.label_list {
  display: flex;
  align-items: center;
  margin-top: 8px;
  .label {
    cursor: pointer;
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 28px;
    margin-right: 15px;
  }
  .acitve_label {
    padding: 0 10px;

    height: 28px;
    color: #146aff;
    background: #cbdeff;
    border-radius: 2px;
  }
}
.Subtag_list {
  padding: 10px;
  min-height: 77px;
  background: #f5f6f7;
  margin-top: 10px;
  display: flex;
  .label_title {
    width: 70px;
    flex-shrink: 0;
    white-space: nowrap;
    // span {
    //   font-family: 'PingFang SC';
    //   font-style: normal;
    //   font-weight: 400;
    //   font-size: 12px;
    //   line-height: 17px;
    //   margin-right: 15px;
    //   color: #7c7f8e;
    // }
  }
  .label_box {
    margin-top: 5px;
    display: flex;
    flex-wrap: wrap;
    div {
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      /* identical to box height */
      margin-right: 10px;
      color: #1f212b;
      // margin-bottom: 10px;
      height: 20px;
      padding: 5px 10px;
    }
    white-space: pre-wrap;
    .acitve_label {
      // height: 28px;
      color: #146aff;
      background: #cbdeff;
      border-radius: 2px;
    }
  }
}
.enterprise_dialog {
  .tip {
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
  }
  .enterprise_box {
    .enterprise_item {
      margin-top: 10px;
      width: 387px;
      padding: 10px;
      background: #f4f4f4;
      border-radius: 1px;
      display: flex;
      justify-content: space-between;
      .left {
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        /* identical to box height */

        color: #151515;
      }
      .right {
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;

        color: #fd5469;
      }
    }
  }
}
.comble_txt {
  span {
    margin-left: 20px;
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
  }
}
.user {
  .container {
    height: 80vh;
    overflow: scroll;
  }
  .form_info {
    background: #ffffff;
    padding: 20px;
  }

  .tab_txt {
    background: #f6f7fb !important;

    margin-top: 20px;
    padding: 0px;
    padding-bottom: 20px;
  }

  .span_div {
    font-size: 14px;
    color: #7c7f8e;
    margin-right: 12px;
  }

  .input-with {
    width: 100%;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    padding: 0px 10px;

    .input-with-select {
      width: 400px;
    }

    .seach {
      background-color: #448aff;
      color: #fff;
      border-radius: 0;
      border: 1px solid #448aff;
      padding: 12px 20px !important;
    }
  }

  .in_table {
    width: 100%;
    margin-top: 20px;

    .img_url {
      width: 42px;
      height: 42px;
      border-radius: 4px;
    }
  }

  .new_page {
    margin: 20px auto;
    width: 100%;
    text-align: center;
  }

  .storeCenter_item {
    width: 100%;
    overflow: hidden;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    border-radius: 4px;
    box-sizing: border-box;
    position: relative;
    .item_checkbox {
      line-height: 36px;
      margin: 0px 10px;
    }
    .Relevancy {
      position: absolute;
      width: 83px;
      height: 25px;
      top: 15px;
      left: 9px;
      background: #ff7d18;
      border-radius: 10px 15px 15px 0px;
      font-size: 12px;
      text-align: center;
      line-height: 25px;
      color: #ffffff;
    }
    .Relevancyblue {
      position: absolute;
      width: 83px;
      height: 25px;
      top: 15px;
      left: 9px;
      background: #146aff;
      border-radius: 10px 15px 15px 0px;
      font-size: 12px;
      text-align: center;
      line-height: 25px;
      color: #ffffff;
    }
    .storeCenter_item_top {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      box-sizing: border-box;
      padding-bottom: 14px;
      position: relative;
      background: #ffffff;
      padding: 16px 20px 10px 10px;
      .storeCenter_item_top_left {
        display: flex;
        flex-direction: row;
        height: 107.73px;
        // width: 30%;
        width: 50%;
        .banner_box {
          position: relative;
          width: 103.55px;
          height: 103.73px;
          padding-right: 20px;
          img {
            width: 103.55px;
            height: 103.73px;
            border-radius: 4px;
            margin-right: 14px;
          }
          .activity_state {
            position: absolute;
            font-family: "PingFang SC";
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 34px;
            text-align: center;
            color: #ffffff;
            top: -10px;
            left: -9px;
            width: 78px;
            height: 34px;
            border-radius: 5px 15px 15px 0;
          }
          .not_started {
            background: #4e93fb;
          }
          .have_in_hand {
            background: #ff7d18;
          }
          .closed {
            background: #999999;
          }
        }

        .storeCenter_item_top_left_flex {
          flex: 1;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .generalVersion {
            background: #448aff;
            border-radius: 2px;
            padding: 5px;
            font-family: "PingFang SC";
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            /* identical to box height */
            margin: 0 10px;
            color: #ffffff;
          }
          .mark_box {
            display: flex;
            img {
              width: 14px;
              // height: 14px;
              margin-right: 6px;
              color: #6e6e6e;
            }
            & > div {
              margin-left: 10px;
            }
          }
          .img_commer {
            display: flex;
            border: 1px solid #146aff;
            border-radius: 39px;
            .name {
              font-size: 12px;
              line-height: 20px;
              color: #146aff;
            }
            .color_img {
              background: #146aff;
              height: 20px;
              width: 25px;
              border-radius: 20px;
              position: relative;
              left: -10px;
              img {
                width: 13px;
                height: 13px;
                position: relative;
                left: 5px;
                top: 2px;
              }
            }
          }
          .img_commers {
            display: flex;
            border: 1px solid #ff9c00;
            border-radius: 39px;
            margin: 0px 10px;
            .name {
              font-size: 12px;
              line-height: 20px;
              color: #ff9c00;
            }
            .color_img {
              background: #ff9c00;
              height: 20px;
              width: 25px;
              border-radius: 20px;
              position: relative;
              left: -10px;
              img {
                width: 13px;
                height: 13px;
                position: relative;
                left: 5px;
                top: 2px;
              }
            }
          }

          h4 {
            color: #1f2d3d;
            font-size: 26px;
            font-weight: 500;
            margin: 0;
          }

          .storeCenter_item_top_left_flex_tag {
            width: 100%;
            display: flex;
            flex-direction: row;
            align-content: center;
            padding-top: 13px;
            margin-bottom: 1px;
            width: 500px;
            span {
              box-sizing: border-box;
              display: block;
              font-size: 14px;
              font-weight: 400;
              border-radius: 4px;
            }

            .office {
              border: 1px solid #559eff;
              color: #4e93fb;
              padding: 1px 6px;
              margin-right: 10px;
              cursor: pointer;
            }

            .support {
              border: 1px solid #fd523f;
              color: #fd523f;
              margin-left: 12px;
              cursor: pointer;
            }
          }

          .address {
            font-size: 14px;
            span {
              padding: 0px 10px;
            }
          }
        }
      }
      .storeCenter_item_top_center {
        display: flex;
        .count_box {
          height: 80px;
          width: 120px;
          align-items: center;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          cursor: pointer;
          // &:nth-of-type(1) {
          //   border-right: 1px solid #e8e8e8;
          // }
          & > div:nth-of-type(1) {
            font-family: "PingFang SC";
            font-style: normal;
            font-weight: 500;
            font-size: 20px;

            color: #078bff;
          }
          & > div:nth-of-type(2) {
            margin-top: 20px;
            font-family: "PingFang SC";
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            color: #333333;
          }
        }
      }
      .storeCenter_item_top_right {
        align-items: stretch;
        height: 100%;

        .operation_area {
          margin-top: 30px;
          .buttom_right {
            height: 36px;
            line-height: 1px;
          }
          .edit {
            padding-left: 20px;
            color: #4e93fb;
            cursor: pointer;
          }
          .frozen {
            padding-left: 20px;
            color: #fd5469;
            cursor: pointer;
          }
        }
        .details {
          text-align: right;
          font-family: "PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 10px;
          color: #999999;
          margin-top: 5px;
        }
      }
    }
  }
  /deep/ .el-radio-button__inner {
    border: none;
    margin-right: 12px;
    border-radius: 4px;
  }
}
/deep/.el-loading-mask {
  background-color: rgba(255, 255, 255, 0.1);
}
/deep/.el-pagination {
  // background: #fff;
  background: #efeff6;
  // padding: 10px 0;
  box-sizing: border-box;
}
</style>
